import React from 'react'
import { inject, observer } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import titleIcon from "app/styles/images/sp/title.svg"
import { Row, Input, message, Modal, Icon } from 'antd'
import './pushModal.scss'
import { observable, action, computed } from 'mobx'
import cx from 'classnames'
import request from "app/vendor/request"
import config from "app/config"

const LightBlueBlock = styled.div`
  background: rgb(241, 248, 255);
  padding: 12px 18px;
`

const SummaryLabel = styled.label`
  line-height: 30px;
  align-self: flex-start;
  flex-shrink: 0;
  text-align: right;
  width: 90px;
`

const BaseInfoItem = styled(Row)`
  margin-bottom: 8px;
  color: rgb(102, 102, 102);

  p {
    color: rgb(51, 51, 51);
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const ExpandBtn = styled.div`
  cursor: pointer;
  margin-left: 6px;
  line-height: 12px;
  border-radius: 2px;
  padding: 3px 6px;
  color: white;
  border: none;
  font-weight: 300;

  &.extend-btn {
    background: #3171af;
  }

  &.close-btn {
    background: #aaa;
  }
`

const Line = styled.div`
  height: 1px;
  flex-grow: 1;
  background: #eeeeee;
`

const RecordWrap = styled.div`
  width: calc(100% + 18px);
  overflow-y: scroll;
  max-height: 160px;
  transition: $transtionExtend;

  &.close {
    max-height: 0;
  }
`

const HiddenScrollBar = styled.div`
  overflow: hidden;
`

const InfoBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 14px;
`

const InfoArea = styled.div`
  display: flex;
  align-items: center;
`

const RightArea = InfoArea.extend`
  font-size: 12px;
  color: rgb(153, 153, 153);
  font-family: 'PingFangSC-Light';
`

const Tag = styled.div`
  padding: 7px 24px;
  background-color: rgb(241, 248, 255);
  font-size: 14px;
  font-family: 'PingFangSC-Semibold';
  color: rgb(44, 112, 174);
  border-radius: 20px;
  line-height: 14px;
`

const GreenBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 162px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  background: rgb(88, 188, 0);
  margin-right: 10px;
  border: none;
  color: white;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

const YellowBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  background: #f8b62d;
  margin-right: 10px;
  border: none;
  color: white;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

const ResetBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  background: #999;
  margin-right: 10px;
  border: none;
  color: white;
  cursor: pointer;
`

const RecordItemContent = styled.div`
  white-space: pre-line;
  font-family: 'PingFangSC-Regular';
  line-height: 17px;
`

const RecordItemWrap = styled.div`
  padding: 0 5px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0
  }
`

@inject('auth') @observer
export default class PushModal extends React.Component {
  @observable showHistory = false
  @observable showHistoryPlus = false
  @observable showHistoryAdvice = false
  @observable pushSubmitData = {
    summary: '',
    summaryGender: '',
    summaryAneu: '',
    summaryCNV: '',
    summaryPloidy: '',
    summaryRoh: '',
    summaryAdvice:''
  }
  @observable btnLocked = false
  constructor(props) {
    super(props)
    this.state = {
      showResetModal: false,
      showResetModalPlus:false,
      showResetModalAdvice:false
    }
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  componentDidMount() {
    const { detailData, getSummaries, getSummariesPlus ,getSummariesAdvice} = this.props.store
    this.handleDataChange()
    getSummaries(detailData.reportId)
    getSummariesPlus(detailData.reportId)
    getSummariesAdvice(detailData.reportId)
    
  }

  handleDataChange = () => {
    const { detailData } = this.props.store
    const { summaries } = this.props
    // 如果返回的记录有值，用之前保存过的，否则从详情内提取
    if (detailData.dataVersion === 'v1.0') {
      this.onPushDataChange('summary',
        summaries[0] ?
          summaries[0].summary :
          `结果：${detailData.resultPos || ''}
      补充结果：${detailData.resultM || ''}`
      )
    } else {
      this.onPushDataChange('summary', `${detailData.resultM || '无'}`)
      this.onPushDataChange('summaryGender', `${detailData.resultGender || '未见异常'}`)
      this.onPushDataChange('summaryAneu', `${detailData.resultAneu || '未见异常'}`)
      this.onPushDataChange('summaryCNV', `${detailData.resultCNV || '未见异常'}`)
      this.onPushDataChange('summaryAdvice', `${detailData.summaryAdvice || ''}`)
      if(detailData.ployStatistical&&(detailData.ployStatistical.Ploidy || detailData.ployStatistical.Zscore)){
        this.onPushDataChange('summaryPloidy', `${this.renderResultMany(detailData) || '未见异常'}`)
        this.onPushDataChange('summaryRoh', `${detailData.rohStatistical.ROHResult || '未见异常'}`)
      }
    }
  }
  renderResultMany = (detailData) => {
    if (detailData.ployStatistical.Ploidy || detailData.ployStatistical.Zscore) {
      var Zscore= (detailData.ployStatistical.Ploidy)+
            (detailData.ployStatistical.Zscore!=='NA'?'('+detailData.ployStatistical.Zscore+')':'')
    } else {
      var Zscore='未见异常'
    }
    return Zscore
  }

  @action onPushDataChange = (field, value) => {
    this.pushSubmitData[field] = value
  }

  @action clearPushData = () => {
    this.pushSubmitData = {
      summary: '',
      summaryGender: '',
      summaryAneu: '',
      summaryCNV: '',
      summaryPloidy: '',
      summaryRoh: '',
      summaryAdvice:''
    }
  }

  @action handleReset = (type) => {
    const { detailData, getSummaries, getSummariesPlus,getSummariesAdvice} = this.props.store
   
    var UrlSuffix= 'summaries/reset'
    if( type === 'Plus'){
      UrlSuffix='summaries/resetPlus'
    }else if( type === 'Advice'){
      UrlSuffix='advice/reset'
    }
    return request.put(`${config.backend}/pgs/reports/${detailData.reportId}/${UrlSuffix}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          message.success('重置成功')
          this.closeResetModal()
          this.closeResetModalPlus()
          this.closeResetModalAdvice()
          getSummaries(detailData.reportId)
          getSummariesPlus(detailData.reportId)
          getSummariesAdvice(detailData.reportId)
          this.pushSubmitData['summaryAdvice'] = ''
        },
        err => {
          message.error(err.message)
          return Promise.reject(err)
        }
      )
  }

  @action showResetModal = () => {
    this.setState({ showResetModal: true })
  }

  @action closeResetModal = () => {
    this.setState({ showResetModal: false })
  }

  @action showResetModalPlus = () => {
    this.setState({ showResetModalPlus: true })
  }

  @action closeResetModalPlus = () => {
    this.setState({ showResetModalPlus: false })
  }
  
  @action showResetModalAdvice = () => {
    this.setState({ showResetModalAdvice: true })
  }

  @action closeResetModalAdvice = () => {
    this.setState({ showResetModalAdvice: false })
  }
  @action handlePush = () => {
    let {
      closeModal,
    } = this.props

    this.btnLocked = true

    if (this.isModify) { // 做过修改了先保存后提交
      this.saveReport('recheck')
        .then(
          res => {
            return this.pushReport()
          }
        ).then(
          res => {
            this.clearPushData()
            closeModal()
          }
        ).finally(
          res => this.btnLocked = false
        )
    } else { // 否则直接提交
      this.pushReport()
        .then(
          res => {
            this.clearPushData()
            closeModal()
          }
        ).finally(
          res => this.btnLocked = false
        )
    }
  }

  @action handlePushPlus = () => {
    let {
      closeModal,
    } = this.props
    
    this.btnLocked = true
    if (this.isModifyPlus) { // 做过修改了先保存后提交
      this.saveReport('Plus')
        .then(
          res => {
            return this.pushReport('Plus')
          }
        ).then(
          res => {
            this.clearPushData()
            closeModal()
          }
        ).finally(
          res => this.btnLocked = false
        )
    } else { // 否则直接提交
      this.pushReport('Plus')
        .then(
          res => {
            this.clearPushData()
            closeModal()
          }
        ).finally(
          res => this.btnLocked = false
        )
    }
  }

  @action pushReport = (type) => {
    const {
      store: { detailData },
      groupId,
      summaries,
      summariesPlus,
    } = this.props
    const UrlSuffix = type ==='Plus' ? 'noticePlus' : 'notice'
    const summaryId = type === 'Plus' ? summariesPlus[0].id:summaries[0].id
    return request.post(
      `${config.backend}/pgs/reports/${UrlSuffix}/${detailData.reportId}?` +
      `summaryId=${summaryId}&groupId=${groupId}`
    )
      .checkToken()
      .commonDispose()
      .then(
        res => {
          message.success('报告推送成功')
          return Promise.resolve()
        },
        err => {
          return Promise.reject()
        }
      )
  }

  @action showHistoryReport = () => {
    this.showHistory = true
  }

  @action toggleHistoryReport = () => {
    this.showHistory = !this.showHistory
  }
  @action toggleHistoryReportPlus = () => {
    this.showHistoryPlus = !this.showHistoryPlus
  }
  @action toggleHistoryReportAdvice = () => {
    this.showHistoryAdvice = !this.showHistoryAdvice
  }

  @computed get isModify() {
    const { summaries } = this.props
    const pushData = this.pushSubmitData
    const summarieData = summaries[0]
    if (summarieData) {
      const isEqualSummary = pushData.summary === summarieData.summary
      const isEqualGender = pushData.summaryGender === summarieData.summaryGender
      const isEqualAneu = pushData.summaryAneu === summarieData.summaryAneu
      const isEqualCNV = pushData.summaryCNV === summarieData.summaryCNV
      if (isEqualSummary && isEqualGender && isEqualAneu && isEqualCNV) {
        return false
      }
    }
    return true
  }
  @computed get isModifyPlus() {
    const { summariesPlus } = this.props
    const pushData = this.pushSubmitData
    const summarieData = summariesPlus[0]
    if (summarieData) {
      const isEqualPloidy = pushData.summaryPloidy === summarieData.summaryPloidy
      const isEqualRoh = pushData.summaryRoh === summarieData.summaryRoh
      if (isEqualPloidy && isEqualRoh) {
        return false
      }
    }
    return true
  }
  @computed get isModifyAdvice() {
    const { summariesAdvice } = this.props
    const pushData = this.pushSubmitData
    const summarieData = summariesAdvice[0]
    if (summarieData) {
      const isEqualAdvice = pushData.summaryAdvice === summarieData.summaryAdvice
      if (isEqualAdvice) {
        return false
      }
    }
    return true
  }

  @action saveReport = (type) => {
    const { detailData, getSummaries, getSummariesPlus, getSummariesAdvice} = this.props.store
    this.btnLocked = true
    this.pushSubmitData.type = type
    var UrlSuffix= 'summaries'
    if(type === 'Plus'){
      UrlSuffix='summariesPlus'
    }else if(type === 'Advice'){ 
      UrlSuffix='advice'
    }

    return request.post(`${config.backend}/pgs/reports/${detailData.reportId}/${UrlSuffix}`)
      .checkToken()
      .send(this.pushSubmitData)
      .commonDispose()
      .then(
        res => {
          message.success('报告结论保存成功')
          return type === 'Plus' ?
            getSummariesPlus(detailData.reportId) :
            type === 'Advice'?
            getSummariesAdvice(detailData.reportId):
            getSummaries(detailData.reportId)
           
        },
        err => {
          message.error(err.message)
          return Promise.reject(err)
        }
      ).finally(
        res => this.btnLocked = false
      )
  }

  renderVersionOne = () => {
    return (
      <Row style={{ flexWrap: 'nowrap', marginTop: 20 }} type='flex' align='middle' justify=''>
        <SummaryLabel>报告结论：</SummaryLabel>
        <Input
          autosize={true}
          style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
          placeholder='请输入报告结论'
          type='textarea'
          value={this.pushSubmitData.summary}
          onChange={(e) => this.onPushDataChange('summary', e.target.value)}
        />
      </Row>
    )
  }
  renderVersionTwo = () => {
    const userInfo = this.props.auth.userInfo
    return (
      <div>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>{userInfo.id === "25" ? '结果：' : '性染色体：' }</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder={userInfo.id === "25" ? '请输入结果结论' : '请输入性染色体结论' }
            type='textarea'
            value={this.pushSubmitData.summaryGender}
            onChange={(e) => this.onPushDataChange('summaryGender', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>{userInfo.id === "25" ? '嵌合：' : '整倍体：' }</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder={userInfo.id === "25" ? '请输入嵌合结论' : '请输入整倍体结论' }
            type='textarea'
            value={this.pushSubmitData.summaryAneu}
            onChange={(e) => this.onPushDataChange('summaryAneu', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>{userInfo.id === "25" ? '小CNV：' : 'CNV：' }</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder={userInfo.id === "25" ? '请输入小CNV结论' : '请输入CNV结论' }
            type='textarea'
            value={this.pushSubmitData.summaryCNV}
            onChange={(e) => this.onPushDataChange('summaryCNV', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>{userInfo.id === "25" ? '备注：' : '补充结果：' }</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder={userInfo.id === "25" ? '请输入备注结论' : '请输入补充结果结论' }
            type='textarea'
            value={this.pushSubmitData.summary}
            onChange={(e) => this.onPushDataChange('summary', e.target.value)}
          />
        </Row>
      </div>
    )
  }
  footerTxt = () =>{
    return (
        <Row type='flex' align='middle' justify='center'>
          <ResetBtn
            onClick={this.showResetModal}
          >
            重置
          </ResetBtn>
          <YellowBtn
            onClick={() => {
              this.isModify ? !this.btnLocked && this.saveReport('check') : message.error('请在修改报告结论后保存')
            }}
          >
            保存结果
          </YellowBtn>
          <GreenBtn
            onClick={!this.btnLocked && this.handlePush}
          >
            推送报告至Lims
          </GreenBtn>
        </Row>
      )
  }
  render() {
    let {
      data = {},
      closeModal,
      store: { detailData },
      auth: { userInfo },
      summaries,
      summariesPlus,
      summariesAdvice
    } = this.props
    let { showResetModal } = this.state
    let { showResetModalPlus } = this.state
    let { showResetModalAdvice } = this.state
    const { showHistory ,showHistoryPlus,showHistoryAdvice} = this
    const extendBtnClass = cx({
      "close-btn": showHistory,
      "extend-btn": !showHistory
    })
    const extendBtnClassPlus = cx({
      "close-btn": showHistoryPlus,
      "extend-btn": !showHistoryPlus
    })
    const extendBtnClassAdvice = cx({
      "close-btn": showHistoryAdvice,
      "extend-btn": !showHistoryAdvice
    })
    const RecordWrapClass = cx({
      "push-record-table": true,
      "close": !showHistory,
    })
    const RecordWrapClassPlus = cx({
      "push-record-table": true,
      "close": !showHistoryPlus,
    })
    const RecordWrapClassAdvice = cx({
      "push-record-table": true,
      "close": !showHistoryAdvice,
    })

    const QualityClass = cx({
      "text-red": detailData.qcOut === "Fail"
    })
    return (
      <MaterialModal
        wrapClassName='push-modal-wrap'
        draggable={true}
        className="push-modal"
        title="报告推送"
        visible={true}
        width={800}
        mask={false}
        footer={detailData.application && (data.appName).indexOf('plus') >-1 ?
          false : this.footerTxt()}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => {
            closeModal()
            this.clearPushData()
          }}
        />
        <LightBlueBlock>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>文件名称：</label>
            <p>{!this.isEmptyObj(detailData) ? detailData.dataName : ""}</p>
          </BaseInfoItem>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>所在分组：</label>
            <p>{data.groupName}</p>
          </BaseInfoItem>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>样本名称：</label>
            <p>{!this.isEmptyObj(detailData) ? detailData.sampleName : []}</p>
          </BaseInfoItem>
          {(userInfo.id === '64' || userInfo.id === '1007' || userInfo.id === '1024') && (
            <BaseInfoItem type='flex' align='middle' justify=''>
              <label>质控信息：</label>
              <p className={QualityClass}>{detailData && detailData.qcOut === "Fail" ? "质控不合格" : '-'}</p>
            </BaseInfoItem>
          )}
        </LightBlueBlock>
        
        {detailData.dataVersion === 'v1.0' ? this.renderVersionOne() : this.renderVersionTwo()}
        {detailData.application && (data.appName).indexOf('plus') >-1 ? 
          <Row type='flex' align='middle' justify='center' >
              <ResetBtn
                style={{height: '28px', marginTop: '10px'}}
                onClick={this.showResetModal}
              >
                重置
              </ResetBtn>
              <YellowBtn
                style={{height: '28px', marginTop: '10px'}}
                onClick={() => {
                  this.isModify ? !this.btnLocked && this.saveReport('check') : message.error('请在修改报告结论后保存')
                }}
              >
                保存结果
              </YellowBtn>
              <GreenBtn
                style={{height: '28px', marginTop: '10px'}}
                onClick={!this.btnLocked && this.handlePush}
              >
                推送报告至Lims
              </GreenBtn>
          </Row>
        :''}
        <Row style={{ marginTop: 20 }} type='flex' justify='start' align='middle' className='subtitle history'>
          <i></i>
          <b>历史记录（{summaries.length}条）</b>
          <Line></Line>
          <ExpandBtn onClick={this.toggleHistoryReport} className={extendBtnClass}>
            {showHistory ? "收起" : "展开"}
          </ExpandBtn>
        </Row>

        <HiddenScrollBar>
          <RecordWrap className={RecordWrapClass}>
            {
              summaries.map((item) => {
                return (
                  <RecordItem
                    key={item.id}
                    store={this.props.store}
                    data={item}
                  />
                )
              })
            }
          </RecordWrap>
        </HiddenScrollBar>
        {showResetModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">重置确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.handleReset('')
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">重置</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={this.closeResetModal}
            />
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <Icon type="reload" />
              <div>重置后数据不可恢复，确认重置？</div>
            </Row>
          </Modal>
        }

        {detailData.application && (data.appName).indexOf('plus') >-1 ? 
          <div>
             <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
              <SummaryLabel>三倍体(异源)：</SummaryLabel>
              <Input
                autosize={true}
                style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
                placeholder='请输入三倍体(异源)结论'
                type='textarea'
                value={this.pushSubmitData.summaryPloidy}
                onChange={(e) => this.onPushDataChange('summaryPloidy', e.target.value)}
              />
            </Row>
            <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
              <SummaryLabel>ROH：</SummaryLabel>
              <Input
                autosize={true}
                style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
                placeholder='请输入ROH结论'
                type='textarea'
                value={this.pushSubmitData.summaryRoh}
                onChange={(e) => this.onPushDataChange('summaryRoh', e.target.value)}
              />
            </Row>
            <Row type='flex' align='middle' justify='center' >
                <ResetBtn
                  style={{height: '28px', marginTop: '10px'}}
                  onClick={this.showResetModalPlus}
                >
                  重置
                </ResetBtn>
                <YellowBtn
                  style={{height: '28px', marginTop: '10px' }}
                  onClick={() => {
                    this.isModifyPlus ? !this.btnLocked && this.saveReport('Plus') : message.error('请在修改报告结论后保存')
                  }}
                >
                  保存结果
                </YellowBtn>
                <GreenBtn
                  style={{height: '28px', marginTop:'10px' }}
                  onClick={!this.btnLocked && this.handlePushPlus}
                >
                  推送报告至Lims
                </GreenBtn>
            </Row>
            <Row style={{ marginTop: 20 }} type='flex' justify='start' align='middle' className='subtitle history'>
              <i></i>
              <b>历史记录（{summariesPlus.length}条）</b>
              <Line></Line>
              <ExpandBtn onClick={this.toggleHistoryReportPlus} className={extendBtnClassPlus}>
                {showHistoryPlus ? "收起" : "展开"}
              </ExpandBtn>
            </Row>

            <HiddenScrollBar>
              <RecordWrap className={RecordWrapClassPlus}>
                {
                  summariesPlus.map((item) => {
                    return (
                      <RecordItemPlus
                        key={item.id}
                        store={this.props.store}
                        data={item}
                      />
                    )
                  })
                }
              </RecordWrap>
            </HiddenScrollBar>
            {showResetModalPlus &&
              <Modal
                className="pgx-modal reportcard-delete-modal"
                title={(
                  <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                    <img src={titleIcon} alt="" />
                    <div className="content">重置确认</div>
                    <img src={titleIcon} alt="" />
                  </Row>
                )}
                visible
                footer={(
                  <Row
                    type="flex"
                    justify="center"
                    align="middle"
                    onClick={
                      () => this.handleReset('Plus')
                    }
                  >
                    <button className="pgx-modal-delete-btn" type="primary">重置</button>
                  </Row>
                )}
              >
                <img
                  className="pgx-modal-close"
                  src={closeIcon}
                  alt="关闭对话框"
                  onClick={this.closeResetModalPlus}
                />
                <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
                  <Icon type="reload" />
                  <div>重置后数据不可恢复，确认重置？</div>
                </Row>
              </Modal>
            }
          </div>
        :''}

        {detailData.application && userInfo.id === "25" ? 
          <div>
            <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
              <SummaryLabel>遗传解读：</SummaryLabel>
              <Input
                autosize={true}
                style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
                placeholder='请输入遗传解读结论'
                type='textarea'
                value={this.pushSubmitData.summaryAdvice}
                onChange={(e) => this.onPushDataChange('summaryAdvice', e.target.value)}
              />
            </Row>
         
            <Row type='flex' align='middle' justify='center' >
                <ResetBtn
                  style={{height: '28px', marginTop: '10px'}}
                  onClick={this.showResetModalAdvice}
                >
                  重置
                </ResetBtn>
                <YellowBtn
                  style={{height: '28px', marginTop: '10px' }}
                  onClick={() => {
                    this.isModifyAdvice ? !this.btnLocked && this.saveReport('Advice') : message.error('请在修改报告结论后保存')
                  }}
                >
                  保存结果
                </YellowBtn>
               
            </Row>
            <Row style={{ marginTop: 20 }} type='flex' justify='start' align='middle' className='subtitle history'>
              <i></i>
              <b>历史记录（{summariesAdvice.length}条）</b>
              <Line></Line>
              <ExpandBtn onClick={this.toggleHistoryReportAdvice} className={extendBtnClassAdvice}>
                {showHistoryAdvice ? "收起" : "展开"}
              </ExpandBtn>
            </Row>

            <HiddenScrollBar>
              <RecordWrap className={RecordWrapClassAdvice}>
                {
                  summariesAdvice.map((item) => {
                    return (
                      <RecordItemAdvice
                        key={item.id}
                        store={this.props.store}
                        data={item}
                      />
                    )
                  })
                }
              </RecordWrap>
            </HiddenScrollBar>
            {showResetModalAdvice &&
              <Modal
                className="pgx-modal reportcard-delete-modal"
                title={(
                  <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                    <img src={titleIcon} alt="" />
                    <div className="content">重置确认</div>
                    <img src={titleIcon} alt="" />
                  </Row>
                )}
                visible
                footer={(
                  <Row
                    type="flex"
                    justify="center"
                    align="middle"
                    onClick={
                      () => this.handleReset('Advice')
                    }
                  >
                    <button className="pgx-modal-delete-btn" type="primary">重置</button>
                  </Row>
                )}
              >
                <img
                  className="pgx-modal-close"
                  src={closeIcon}
                  alt="关闭对话框"
                  onClick={this.closeResetModalAdvice}
                />
                <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
                  <Icon type="reload" />
                  <div>重置后数据不可恢复，确认重置？</div>
                </Row>
              </Modal>
            }
          </div>
        :''}

      </MaterialModal>
    )
  }
}

class RecordItem extends React.Component {
  renderRecordContent = () => {
    const { data } = this.props
    const { detailData } = this.props.store
    if (detailData.dataVersion === 'v1.0') {
      return (
        <RecordItemContent>
          {data.summary}
        </RecordItemContent>
      )
    } else if (detailData.dataVersion === 'v2.0') {
      return (
        <div>
          <RecordItemContent>
          {data.userId === "25" ? '结果：' : '性染色体：' }{data.summaryGender || '未见异常'}
          </RecordItemContent>
          <RecordItemContent>
          {data.userId === "25" ? '嵌合：' : '整倍体：' }{data.summaryAneu || '未见异常'}
           </RecordItemContent>
          <RecordItemContent>
          {data.userId === "25" ? '小CNV：' : 'CNV：' }{data.summaryCNV || '未见异常'}
          </RecordItemContent>
          <RecordItemContent>
          {data.userId === "25" ? '备注：' : '补充结果：' }{data.summary || '无'}
          </RecordItemContent>
        </div>
      )
    }
  }
  render() {
    const { data } = this.props
    return (
      <RecordItemWrap>
        {this.renderRecordContent()}
        <InfoBar>
          <InfoArea>
            {data.send && (
              <Tag>已推送</Tag>
            )}
          </InfoArea>

          <RightArea>
            保存时间：{data.updateAt}
          </RightArea>
        </InfoBar>
        <Line />
      </RecordItemWrap>
    )
  }
}
class RecordItemAdvice extends React.Component {
  renderRecordContent = () => {
    const { data } = this.props
      return (
        <div>
          <RecordItemContent>
          {'遗传解读：'}{data.summaryAdvice || ''}
          </RecordItemContent>
        </div>
      )
    
  }
  render() {
    const { data } = this.props
    return (
      <RecordItemWrap>
        {this.renderRecordContent()}
        <InfoBar>

          <RightArea>
            保存时间：{data.updateAt}
          </RightArea>
        </InfoBar>
        <Line />
      </RecordItemWrap>
    )
  }
}

class RecordItemPlus extends React.Component {
  renderRecordContent = () => {
    const { data } = this.props
      return (
        <div>
          <RecordItemContent>
          {'三倍体(异源)：'}{data.summaryPloidy || '未见异常'}
          </RecordItemContent>
          <RecordItemContent>
          {'ROH ：'}{data.summaryRoh || '未见异常'}
          </RecordItemContent>
        </div>
      )
    
  }
  
  render() {
    const { data } = this.props
    return (
      <RecordItemWrap>
        {this.renderRecordContent()}
        <InfoBar>
          <InfoArea>
            {data.send && (
              <Tag>已推送</Tag>
            )}
          </InfoArea>

          <RightArea>
            保存时间：{data.updateAt}
          </RightArea>
        </InfoBar>
        <Line />
      </RecordItemWrap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/PushModal.js